import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import IGlobalState from '@/interfaces/IGlobalState';
import state        from './state';
import getters      from './getters';
import mutations    from './mutations';
import actions      from './actions';

Vue.use(Vuex);

// Ustawienia wartosci w localStorage dla wczytywania domyslnych ustawien z api
!localStorage.getItem('defaultSettings')
  ? localStorage.setItem('defaultSettings', 'true')
  : localStorage.setItem('defaultSettings', 'false');

const vuexLocal = new VuexPersistence<IGlobalState>({
  storage: window.localStorage,
  reducer: (reducedState: IGlobalState) => ({
    mapSettings: {
      mapConfiguration: reducedState.mapSettings.mapConfiguration,
    },
  }),
});

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin],
});
